var _defs, _rect, _circle, _circle2, _tspan, _tspan2, _tspan3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSubscriptionFreeIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 97.502,
    height: 76.664,
    viewBox: "0 0 97.502 76.664",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "@import url('https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap');"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "subscription-free-icon-a",
    x1: 0.5,
    y1: -0.253,
    x2: 0.5,
    y2: 0.913,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f24040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b50e0e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "subscription-free-icon-b",
    x1: 0.5,
    y1: 0.046,
    x2: 0.5,
    y2: 0.958,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffdf00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffb100"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-219.786 -168.639)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 71.491,
    height: 38.802,
    transform: "translate(245.796 187.57)",
    fill: "url(#subscription-free-icon-a)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 38.332,
    cy: 38.332,
    r: 38.332,
    transform: "translate(219.786 168.639)",
    fill: "#0472a3"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 35.468,
    cy: 35.468,
    r: 35.468,
    transform: "translate(222.542 171.503)",
    fill: "url(#subscription-free-icon-b)"
  })), /*#__PURE__*/React.createElement("text", {
    transform: "translate(258.542 215.979)",
    fontSize: 21,
    style: {
      fontFamily: "'Montserrat', sans-serif"
    },
    fontWeight: 700
  }, _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    x: -27.583,
    y: 0
  }, "100%"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(258.542 228.319)",
    fontSize: 11,
    style: {
      fontFamily: "'Montserrat', sans-serif"
    },
    fontWeight: 700
  }, _tspan2 || (_tspan2 = /*#__PURE__*/React.createElement("tspan", {
    x: -14.938,
    y: 0
  }, "FREE"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(258.542 194.643)",
    fontSize: 8,
    style: {
      fontFamily: "'Montserrat', sans-serif"
    },
    fontWeight: 700
  }, _tspan3 || (_tspan3 = /*#__PURE__*/React.createElement("tspan", {
    x: -24.244,
    y: 0
  }, "SUBSCRIBE")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubscriptionFreeIcon);
export default __webpack_public_path__ + "static/media/subscription-free-icon.926a21348e338ecb810460ac23b40e7d.svg";
export { ForwardRef as ReactComponent };